module.exports = __webpack_public_path__ + "img/var_02_xrobot2.ac9f0886.png";